import { Stack, StackItem } from "@fluentui/react";
import React, { FunctionComponent, useMemo } from "react";
import { Link } from "react-router-dom";
import { localize } from "src/l10n";
import { getFileIconUrl } from "src/office365/utils";
import { Label } from "src/ui";
import { decodeHtmlEntities } from "src/utils";
import "./ModernSearchResultObjectHit.scss";
import { SpintrTypes } from "src/typings";

interface IProps {
    item?: Spintr.ISearchResult;
    officeItem?: Spintr.IOffice365FileSearchItem;
    onClick?(item: any): void;
}

const AOrLink = (props) => {
    const isInternal = !props.to || props.to.startsWith(window.location.origin) || props.to.startsWith("/");

    if (isInternal) {
        return <Link {...props}>{props.children}</Link>;
    } else {
        return (
            <a href={props.to} className={props.className} target="_blank" rel="noreferrer">
                {props.children}
            </a>
        );
    }
};

const ModernSearchResultObjectHit: FunctionComponent<IProps> = (props) => {
    const item = props.item ? props.item : props.officeItem;

    const { onClick } = props;

    const onItemClick = () => {
        if (!onClick) {
            return;
        }

        onClick(item);
    };

    const text = decodeHtmlEntities(item.caption, false);

    const officeIconSrc = getFileIconUrl(item);

    const typeText = useMemo(() => {
        if (props.item) {
            return localize(`Ubertype${item.type}_0_4`);
        }

        if (props.officeItem) {
            return props.officeItem.serviceType && props.officeItem.serviceType === 1 ? "OneDrive" : "SharePoint";
        }

        return "";
    }, [props.item, props.officeItem]);

    return (
        <AOrLink onClick={onItemClick} to={item.url} className={"ModernSearchResultObjectHit type" + item.type}>
            <div className="content">
                <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 4 }}>
                    <div className="name">
                        {!!props.officeItem && <img src={officeIconSrc} alt="" />}
                        <Label size="body-5" color="dark-grey" weight="medium" title={item.name}>
                            {item.name}
                        </Label>
                    </div>

                    <StackItem disableShrink className="type">
                        <Label size="body-2" weight="medium" color="primaryContent">
                            {typeText}
                        </Label>
                    </StackItem>
                </Stack>

                {!!text && item.type !== SpintrTypes.UberType.File && item.type !== SpintrTypes.UberType.Gallery && (
                    <div className="description">
                        <Label size="body-2" color="primaryContent">
                            {decodeHtmlEntities(text)}
                        </Label>
                    </div>
                )}
            </div>
        </AOrLink>
    );
};

export default ModernSearchResultObjectHit;
